// extracted by mini-css-extract-plugin
export default {"cards":"blogCard_cards__9Mbz8","image":"blogCard_image__2cXh1","title":"blogCard_title__iA4J-","summary":"blogCard_summary__ej9I6"};